import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import style from "./modal.module.css";
import { setScrolling } from "../../helpers/scroll";
interface moladProp {
  children?: React.ReactNode;
  onClose?: () => void;
  isModal?: boolean;
  className?: string;
  animation?: string;
  overlayClass?: string;
}
export const Overlay: React.FC<moladProp> = function ({
  onClose,
  overlayClass,
}) {
  return (
    <div
      className={`${style.overlay} z-800 ${overlayClass}`}
      onClick={onClose}
    ></div>
  );
};
export const ModalContent: React.FC<moladProp> = function ({
  children,
  className,
  animation,
}) {
  return (
    <div className={`${style.modal} z-900`}>
      <div
        className={`${style.inner} ${className} ${
          animation ? animation : "ani-open-modal"
        } z-900`}
      >
        {children}
      </div>
    </div>
  );
};

const Modal: React.FC<moladProp> = ({
  children,
  onClose,
  isModal,
  className,
  animation,
  overlayClass,
}) => {
  const handleCloseMOdal = function () {
    if (onClose) onClose();
  };
  useEffect(() => {
    if (isModal) {
      setScrolling("none");
    } else {
      setScrolling("auto");
    }
  }, [isModal]);
  return (
    <React.Fragment>
      {isModal && (
        <>
          {ReactDOM.createPortal(
            <Overlay onClose={handleCloseMOdal} overlayClass={overlayClass} />,
            document.body!
          )}
          {ReactDOM.createPortal(
            <ModalContent
              children={children}
              className={className}
              animation={animation}
              onClose={handleCloseMOdal}
            />,
            document.body!
          )}
        </>
      )}
    </React.Fragment>
  );
};

export default Modal;
